__turbopack_context__.v({
  "testscenariocontainer": "P3iaBq_testscenariocontainer",
});
